// HomeWeb.jsx
import React, { useState, useRef } from 'react';
import { Text, ScrollView, View, Image, TouchableOpacity, Platform, TouchableWithoutFeedback, TextInput, KeyboardAvoidingView, Alert } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from '../../components/baseWeb';
import styles from '../../styles/formularios';
import axios from 'axios';
import MaskInput, { Masks } from 'react-native-mask-input'; // Para aplicar máscara no CPF
import Checkbox from 'expo-checkbox';
export default function DadosImovelPromessaWeb({ route }) {
  const navigation = useNavigation();
  // envio unico 

  const [usuario_id, setUsuario_id] = useState(null);
  const { payload_vendedores, payload_compradores } = route.params || {};


  const cepInputRef = useRef(null);
  const enderecoInputRef = useRef(null);
  const complementoInputRef = useRef(null);
  const bairroInputRef = useRef(null);
  const cidadeUfInputRef = useRef(null);
  const matriculaImovelRef = useRef(null);

  const [cep, setCep] = useState('');
  const [endereco, setEndereco] = useState('');
  const [bairro, setBairro] = useState('');
  const [cidadeUf, setCidadeUf] = useState('');
  const [complemento, setComplemento] = useState('');

  const [matriculaImovel, setMatriculaImovel] = useState('');
  const [numeroCartorio, setNumeroCartorio] = useState('');
  const [showCartorioOptions, setShowCartorioOptions] = useState(false);
  const [isImob, setIsImob] = useState(false); // OK 
  const toggleIsImob = () => setIsImob(prev => !prev);

  const toggleGravame = () => setGravame(prev => !prev);
  const tipoGravameRef = useRef(null);
  const beneficiarioGravameRef = useRef(null);
  const beneficiarioGravameCnpjRef = useRef(null);
  const registroGravameRef = useRef(null);
  const relacaoMoveisRef = useRef(null);
  // GRAVAME
  const [gravame, setGravame] = useState(false);
  const [modalGravameVisible, setModalGravameVisible] = useState(false);
  const [tipoGravame, setTipoGravame] = useState('');
  const [beneficiarioGravame, setBeneficiarioGravame] = useState('');
  const [beneficiarioCnpjGravame, setBeneficiarioCnpjGravame] = useState('');
  const [registroGravame, setRegistroGravame] = useState('');

  // ITENS DO IMÓVEL
  const [temItensImovel, setTemItensImovel] = useState(false);
  const [modalItensVisible, setModalItensVisible] = useState(false);
  const [relacaoMoveis, setRelacaoMoveis] = useState('');

  const handleCepChange = (text) => {
    const formattedCep = text.replace(/\D/g, '').replace(/(\d{5})(\d{3})/, '$1-$2');
    setCep(formattedCep);
    if (formattedCep.length === 9) {
      buscaCep(formattedCep);
    }
  };
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSaveImovel = async () => {
    const enderecoFull = `${endereco}, ${complemento}, ${bairro} - ${cidadeUf}`;
    const payload = {
      "endereco_imovel": enderecoFull,
      "matricula_imovel": matriculaImovel,
      "numero_cartorio": numeroCartorio,
      "gravame": gravame,
      "tipo_gravame": tipoGravame,
      "beneficiario_gravame": beneficiarioGravame,
      "beneficiario_cnpj_gravame": beneficiarioCnpjGravame,
      "registro_gravame": registroGravame,
      "relacao_movies": relacaoMoveis
    };

    console.log(payload)
    navigation.navigate('EtapasPromessaWeb', { payload_vendedores, payload_compradores, status: 4, payload_imovel_one: payload });
    setIsSubmitting(true);
  };

  const isFormValid = () => cep && endereco && bairro && cidadeUf && matriculaImovel && numeroCartorio;

  const buscaCep = async (cep) => {
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep.replace('-', '')}/json/`);
      if (response.data) {
        setEndereco(response.data.logradouro);
        setBairro(response.data.bairro);
        setCidadeUf(`${response.data.localidade}/${response.data.uf}`);
      }
    } catch (error) {
      Alert.alert('Erro', 'Não foi possível buscar o CEP');
    }
  };

  return (
    <BaseWeb>
      {(userInfo) => {
        return (
          <ScrollView contentContainerStyle={styles.contentMinimal}>
            <View style={styles.formContainer}>
              <Text style={styles.title}>Dados do imóvel</Text>

              {/* CEP */}
              <View style={styles.row}>
                <Text style={styles.subLabel}>CEP *</Text>
                <TouchableWithoutFeedback onPress={() => cepInputRef.current.focus()}>
                  <View style={styles.inputContainer}>
                    <TextInput
                      ref={cepInputRef}
                      allowFontScaling={false}
                      style={styles.areaInput}
                      placeholder="00000-000"
                      placeholderTextColor="#A9A9A9"
                      value={cep}
                      onChangeText={handleCepChange}
                      keyboardType="numeric"
                      maxLength={9}
                    />
                  </View>
                </TouchableWithoutFeedback>
              </View>

              {/* Endereço */}
              <View style={styles.row}>
                <Text style={styles.subLabel}>Endereço *</Text>
                <TouchableWithoutFeedback onPress={() => enderecoInputRef.current.focus()}>
                  <View style={styles.inputContainer}>
                    <TextInput
                      ref={enderecoInputRef}
                      allowFontScaling={false}
                      style={styles.areaInput}
                      placeholder="Rua, Avenida..."
                      placeholderTextColor="#A9A9A9"
                      value={endereco}
                      onChangeText={setEndereco}
                    />
                  </View>
                </TouchableWithoutFeedback>
              </View>

              {/* Complemento */}
              <View style={styles.row}>
                <Text style={styles.subLabel}>Complemento (opcional)</Text>
                <TouchableWithoutFeedback onPress={() => complementoInputRef.current.focus()}>
                  <View style={styles.inputContainer}>
                    <TextInput
                      ref={complementoInputRef}
                      allowFontScaling={false}
                      style={styles.areaInput}
                      placeholder="Apto, Bloco..."
                      placeholderTextColor="#A9A9A9"
                      value={complemento}
                      onChangeText={setComplemento}
                    />
                  </View>
                </TouchableWithoutFeedback>
              </View>

              {/* Bairro */}
              <View style={styles.row}>
                <Text style={styles.subLabel}>Bairro *</Text>
                <TouchableWithoutFeedback onPress={() => bairroInputRef.current.focus()}>
                  <View style={styles.inputContainer}>
                    <TextInput
                      ref={bairroInputRef}
                      allowFontScaling={false}
                      style={styles.areaInput}
                      placeholder="Bairro"
                      placeholderTextColor="#A9A9A9"
                      value={bairro}
                      onChangeText={setBairro}
                    />
                  </View>
                </TouchableWithoutFeedback>
              </View>

              {/* Cidade/UF */}
              <View style={styles.row}>
                <Text style={styles.subLabel}>Cidade/UF *</Text>
                <TouchableWithoutFeedback onPress={() => cidadeUfInputRef.current.focus()}>
                  <View style={styles.inputContainer}>
                    <TextInput
                      ref={cidadeUfInputRef}
                      allowFontScaling={false}
                      style={styles.areaInput}
                      placeholder="Cidade/UF"
                      placeholderTextColor="#A9A9A9"
                      value={cidadeUf}
                      onChangeText={setCidadeUf}
                    />
                  </View>
                </TouchableWithoutFeedback>
              </View>
              <View style={styles.divider} />
              {/* Matrícula do Imóvel */}
              <View style={styles.row}>
                <Text style={styles.subLabel} allowFontScaling={false}>Matrícula do Imóvel *</Text>
                <TouchableWithoutFeedback onPress={() => matriculaImovelRef.current.focus()}>
                  <View style={styles.inputContainer}>
                    <TextInput
                      ref={matriculaImovelRef}
                      allowFontScaling={false}
                      style={styles.areaInput}
                      placeholder="Digite o número da matrícula"
                      placeholderTextColor="#A9A9A9"
                      value={matriculaImovel}
                      onChangeText={setMatriculaImovel}
                    />
                  </View>
                </TouchableWithoutFeedback>
              </View>

              {/* Número do Cartório (Select personalizado) */}
              <View style={styles.row}>
                <Text style={styles.subLabel} allowFontScaling={false}>Cartório de Registro do Imóvel*</Text>
                <TouchableWithoutFeedback onPress={() => setShowCartorioOptions(!showCartorioOptions)}>
                  <View style={[styles.areaInput, { justifyContent: 'center' }]}>
                    <Text style={{ color: numeroCartorio ? '#1F2024' : '#A9A9A9' }}>
                      {numeroCartorio || 'Selecionar cartório'}
                    </Text>
                  </View>
                </TouchableWithoutFeedback>

                {showCartorioOptions && (
                  <View style={styles.optionsContainer}>
                    {[
                      '1º Ofício de Registro de Imóveis do DF',
                      '2º Ofício de Registro de Imóveis do DF',
                      '3º Ofício de Registro de Imóveis do DF',
                      '4º Ofício de Registro de Imóveis do DF',
                      '5º Ofício de Registro de Imóveis do DF',
                      '6º Ofício de Registro de Imóveis do DF',
                      '7º Ofício de Registro de Imóveis do DF',
                      '8º Ofício de Registro de Imóveis do DF',
                      '9º Ofício de Registro de Imóveis do DF',
                    ].map((option) => (
                      <TouchableOpacity
                        key={option}
                        style={styles.optionItem}
                        onPress={() => {
                          setNumeroCartorio(option);
                          setShowCartorioOptions(false);
                        }}
                      >
                        <Text style={styles.optionText}>{option}</Text>
                      </TouchableOpacity>
                    ))}
                  </View>
                )}
              </View>
              {/* Checkbox "Não possui condomínio" */}
              <View style={styles.checkboxRow}>
                <Checkbox
                  value={gravame}
                  onValueChange={toggleGravame}
                  color={gravame ? '#730d83' : undefined}
                />
                <Text style={styles.checkboxLabel} allowFontScaling={false}>O imóvel possui gravame? </Text>
              </View>
              {gravame && (
                <View style={[styles.row, styles.mt_20]}>
                  <Text style={styles.subTitulo} allowFontScaling={false}>Informações do gravame</Text>
                  <View style={styles.row}>
                    <Text style={styles.subLabel} allowFontScaling={false}>Tipo de Gravame*</Text>
                    <TouchableWithoutFeedback onPress={() => tipoGravameRef.current.focus()}>
                      <View style={styles.inputContainer}>
                        <TextInput
                          ref={tipoGravameRef}
                          allowFontScaling={false}
                          style={styles.areaInput}
                          placeholder="Ex: Alienação Fiduciária"
                          value={tipoGravame}
                          placeholderTextColor="#A9A9A9"
                          onChangeText={setTipoGravame}
                        />
                      </View>
                    </TouchableWithoutFeedback>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.subLabel} allowFontScaling={false}>Beneficiario do Gravame*</Text>
                    <TouchableWithoutFeedback onPress={() => beneficiarioGravameRef.current.focus()}>
                      <View style={styles.inputContainer}>
                        <TextInput
                          ref={beneficiarioGravameRef}
                          allowFontScaling={false}
                          style={styles.areaInput}
                          placeholder="Razão Social"
                          value={beneficiarioGravame}
                          placeholderTextColor="#A9A9A9"
                          onChangeText={setBeneficiarioGravame}
                        />
                      </View>
                    </TouchableWithoutFeedback>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.subLabel} allowFontScaling={false}>CNPJ do Beneficiário*</Text>
                    <TouchableWithoutFeedback onPress={() => beneficiarioGravameCnpjRef.current.focus()}>
                      <View style={styles.inputContainer}>
                        <MaskInput
                          ref={beneficiarioGravameCnpjRef}
                          allowFontScaling={false}
                          style={styles.areaInput}
                          value={beneficiarioCnpjGravame}
                          onChangeText={setBeneficiarioCnpjGravame}
                          mask={Masks.BRL_CNPJ}
                          placeholderTextColor="#A9A9A9"
                          keyboardType="numeric"
                          placeholder="12.345.678/0001-90"
                        />
                      </View>
                    </TouchableWithoutFeedback>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.subLabel} allowFontScaling={false}>Número de registro no gravame*</Text>
                    <TouchableWithoutFeedback onPress={() => registroGravameRef.current.focus()}>
                      <View style={styles.inputContainer}>
                        <TextInput
                          ref={registroGravameRef}
                          allowFontScaling={false}
                          style={styles.areaInput}
                          placeholder="R-12345"
                          value={registroGravame}
                          keyboardType='number-pad'
                          placeholderTextColor="#A9A9A9"
                          onChangeText={setRegistroGravame}
                        />
                      </View>
                    </TouchableWithoutFeedback>
                  </View>
                </View>
              )}
              <View style={styles.checkboxRow}>
                <Checkbox
                  value={isImob}
                  onValueChange={toggleIsImob}
                  color={isImob ? '#730d83' : undefined}
                />
                <Text style={styles.checkboxLabel} allowFontScaling={false}>Algum item permanecerá no imóvel? </Text>
              </View>
              {isImob && (
                <View style={[styles.row, styles.mt_20]}>
                  <View style={styles.row}>
                    <Text style={styles.subLabel} allowFontScaling={false}>Relação de móveis*</Text>
                    <TouchableWithoutFeedback onPress={() => relacaoMoveisRef.current.focus()}>
                      <View style={styles.inputContainer}>
                        <TextInput
                          ref={relacaoMoveisRef}
                          style={[styles.areaInput]}
                          multiline
                          value={relacaoMoveis}
                          onChangeText={setRelacaoMoveis}
                          placeholder="Ex: Fogão embutido, armários planejados..."
                          placeholderTextColor="#A9A9A9"
                        />
                      </View>
                    </TouchableWithoutFeedback>
                  </View>


                </View>
              )}

              <View style={styles.divider} />

              <View style={styles.buttonContainer}>
                <TouchableOpacity
                  style={[
                    styles.saveButton,
                    (!isFormValid() || isSubmitting) && { backgroundColor: '#ccc' },
                  ]}
                  onPress={handleSaveImovel}
                  disabled={!isFormValid() || isSubmitting}
                >
                  <Text style={styles.saveButtonText}>
                    {isSubmitting ? 'Enviando...' : 'Próximo'}
                  </Text>
                </TouchableOpacity>

                <TouchableOpacity
                  style={styles.laterButton}
                  onPress={() => navigation.navigate('Home', { usuario_id })}
                >
                  <Image source={require('../../../assets/icons/home.png')} style={styles.laterIcon} />
                  <Text style={styles.laterButtonText}>Voltar</Text>
                </TouchableOpacity>
              </View>

            </View>
          </ScrollView>
        );
      }}
    </BaseWeb>
  );
}
